import { Component } from '@angular/core';
import { ModulesService } from '../../services/modules.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { User, UserTier } from '../../models/User';
import { AuthService } from '../../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { Module } from '../../models/Module';
import { Level } from '../../models/ScoresResponse';
import { CommonModule } from '@angular/common';
import { Role } from '../../models/Role';
import { ModalService } from '../../services/modal.service';
import { PaymentModalComponent } from '../modales/payment-modal/payment-modal.component';
import { ScoreService } from '../../services/score.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-module-start',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './module-start.component.html',
    styleUrl: './module-start.component.scss',
})
export class ModuleStartComponent {
    user?: User;
    module?: Module;
    moduleId: string;
    color?: string;
    canPlay: boolean = false;
    isTp: boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthService,
        private moduleService: ModulesService,
        private modalService: ModalService,
        private scoreService: ScoreService
    ) {}

    async ngOnInit() {
        this.isTp = this.router.url.includes('_tp');
        this.user = await firstValueFrom(
            this.authService.getUserInfoOrRefreshIfNeeded()
        );

        this.route.params.subscribe((params: Params) => {
            this.moduleId = params['id'];
            this.color = params['color'];
            this.updateInfos();
        });
    }

    private getRole(): Role {
        return this.isTp ? Role.professeur : Role.enfant;
    }

    private async updateInfos() {
        let scores = await firstValueFrom(
            this.authService.getMyScores(this.getRole())
        );
        let modules = await firstValueFrom(this.moduleService.getAllModules());

        const moduleScore = scores.data[0].progresses.find(
            (elt) => elt.module_id === this.moduleId
        );
        if (!moduleScore) {
            return;
        }
        this.module = modules.find((elt) => elt.module_enum === this.moduleId);
        this.canPlay = !moduleScore.validated_leagues.includes(Level.diamant);
        let nextLevel = this.scoreService.getNextLevel(
            moduleScore.validated_leagues
        );

        if (!nextLevel) {
            return;
        }

        const shouldAllow = await this.moduleService.canSelectModule(
            this.user?.tier ?? UserTier.free,
            nextLevel,
            this.moduleId
        );

        if (!shouldAllow) {
            this.openPaymentModal();
        }
    }

    getModuleImg() {
        if (!this.module) {
            return '';
        }

        return this.module.illustration_url;
    }

    getTextColor(): any {
        let obj: any = {
            color: `${this.moduleService.getModuleColorName(
                this.moduleId,
                this.color
            )}`,
        };

        return obj;
    }

    getButtonBgColor(): any {
        let obj: any = {
            'background-color': `${this.moduleService.getModuleColorName(
                this.moduleId,
                this.color
            )}`,
        };

        return obj;
    }

    startPlaying() {
        if (this.color) {
            this.router.navigate(['module_take_tp', this.color, this.moduleId]);
        } else {
            this.router.navigate(['module_take', this.moduleId]);
        }
    }

    openPaymentModal() {
        const modalRef = this.modalService.open(PaymentModalComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });

        modalRef.result.then((result) => {
            if (result === 'cancel') {
                this.router.navigate(['']);
            }
        });
    }
}
